import React, { useEffect, useState } from 'react';
import { Form, Input, Button, message } from 'antd';
import { controller } from '../controller';
import { useDropzone } from 'react-dropzone';

// icon
import dragDropIcon from "../assets/icon/export.png"

// The phone field renders a fixed "+1 " prefix, so a stored "+1 416 555 0100"
// would read "+1 +1 416…". Drop a leading North-American country code only —
// never a bare leading digit, which could be part of a local number.
const stripCountryCode = (raw) => {
    const s = String(raw || "").trim();
    if (/^\+1/.test(s)) return s.replace(/^\+1[\s\-.]*/, "");
    const digits = s.replace(/\D/g, "");
    if (digits.length === 11 && digits[0] === "1") return s.replace(/^1[\s\-.]*/, "");
    return s;
};

const CreatePractice = (props) => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [logo, setLogo] = React.useState(null);
    const [logoError, setLogoError] = useState(false);

    // Seed the form from what the lead/invite already told us — once, on mount,
    // and only into fields still empty, so nothing the user typed while the
    // request was in flight is overwritten. Prefill is a convenience: any
    // failure is swallowed and onboarding proceeds with a blank form.
    const [prefilled, setPrefilled] = useState(false);
    useEffect(() => {
        let cancelled = false;
        (async () => {
            try {
                const p = await controller.getOnboardingPrefill();
                if (cancelled || !p || typeof p !== 'object') return;
                const values = {};
                if (p.practice_name) values.name = p.practice_name;
                // Invite-sourced prefill carries contact_phone only; a lead carries phone.
                const phone = p.phone || p.contact_phone;
                if (phone) values.phone = stripCountryCode(phone);
                const current = form.getFieldsValue();
                Object.keys(values).forEach((k) => { if (current[k]) delete values[k]; });
                if (!Object.keys(values).length) return;
                form.setFieldsValue(values);
                setPrefilled(true);
            } catch (e) {
                // Never block onboarding over a prefill.
            }
        })();
        return () => { cancelled = true; };
    }, [form]);

    const onDrop = React.useCallback((acceptedFiles) => {
        // Do something with the dropped files
        if (acceptedFiles && acceptedFiles.length > 0) {
            setLogo(acceptedFiles[0]);
            setLogoError(false);
        }
    }, []);

    const { getRootProps, getInputProps } = useDropzone({
        onDrop,
        accept: 'image/png, image/jpeg',
    });
    const onFinish = async (values) => {
        // Validate the logo with an inline field error BEFORE touching the
        // form — and bail early so the entered data is never wiped.
        if (!logo) {
            setLogoError(true);
            return;
        }
        setLoading(true);
        try {
            let formData = new FormData();
            formData.append("name", values.name);
            formData.append("phone", values.phone);
            formData.append("logo", logo);
            const response = await controller.createPractice(formData)
            if (response.status < 250) {
                props.readOnboardingStatus()
                message.success("Created practice was successful")
                // Clear the form ONLY on success.
                form.resetFields();
                setLogo(null);
            } else {
                message.error(
                    response.email ?
                        response.email :
                        response.phone ?
                            response.phone :
                            response.detail ?
                                response.detail :
                                response.error ?
                                    response.error :
                                    "Error during creating practice"
                )
            }
        } catch (e) {
            message.error("Error during creating practice")
        } finally {
            setLoading(false)
        }
    };

    const onFinishFailed = (errorInfo) => {
        console.log('Failed:', errorInfo);
    };


    return (
        <div className="your-component-container">
            <p style={{ fontSize: "24px", fontWeight: "600" }}>Create an Account</p>
            <p style={{ fontSize: "20px", fontWeight: "500", marginBottom: 37 }}>Basic Information of your Practice</p>
            {prefilled && (
                <p style={{ color: "#918da1", fontSize: 13, marginTop: -24, marginBottom: 28 }}>
                    We&rsquo;ve pre-filled what you told us &mdash; edit anything that&rsquo;s changed.
                </p>
            )}


            <Form
                form={form}
                name="basic"
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
            >
                <div className='input-lable'>Name</div>
                <Form.Item
                    label=""
                    name="name"
                    rules={[{ required: true, message: 'Please input your name!' }]}
                    style={{marginBottom: 20}}
                >
                    <Input style={{ width: '100%', height: 39 }} placeholder="Enter your name" />
                </Form.Item>

                <div className='input-lable'>Phone</div>
                <Form.Item
                    label=""
                    name="phone"
                    rules={[{ required: true, message: 'Please input your phone number!' }]}
                    style={{marginBottom: 20}}

                >
                    <Input prefix="+1 " style={{ width: '100%', height: 39 }} placeholder="Enter your phone number" />
                </Form.Item>

                <div className='input-lable'>Logo</div>
                <div {...getRootProps()} className="drop-zone">
                    <input {...getInputProps()} id="inputImageFile" type="file" name="file" />
                    <div className="tac">
                        {logo ? (
                            <img width="150" height="100" alt="avatar" src={URL.createObjectURL(logo)} />
                        ) : (
                            <div>
                                <img src={dragDropIcon} width={20} alt="drag" />
                                <p className='dragDroptext mt15'>Drag and drop or <span className='dragDropBtn'>Browse</span> your files</p>
                            </div>

                        )}
                    </div>
                </div>
                {logoError && (
                    <div className="ant-form-item-explain-error" style={{ color: '#ff4d4f', marginTop: 6, fontSize: 14 }}>
                        Please upload a logo
                    </div>
                )}
                <div className='mt15'></div>
                <Form.Item>
                    <Button htmlType="submit" className='login-button' loading={loading} style={{marginTop: 25}}>
                        Next
                    </Button>
                </Form.Item>
            </Form>
        </div>
    );
};

export default CreatePractice;
